import { URL } from "../../api/Api";
import { CANDIDATE } from "../Action";
import { catchError, DELETE, GET, getToken, POST, PUT } from "../axios/Axios";

export const SearchAndListOfResumes = async (payload, params) => {
  try {
    const response = await POST(`${URL}/resume/search/filter`, payload, params);

    return response.data;
  } catch (error) {
    throw catchError(error);
  }
};

export const CandidateViewCall = (job_id) => {
  return async (dispatch) => {
    try {
      const response = await GET(`${URL}/resume/resumedata/${job_id}`, {});
      dispatch({ type: CANDIDATE.candidateView, data: response.data });

      return response.data;
    } catch (error) {
      throw catchError(error);
    }
  };
};

export const AddToJobPoolList = async () => {
  try {
    const response = await GET(`${URL}/resume/job/match/`, {});
    return response;
  } catch (error) {
    throw catchError(error);
  }
};

export const AddToJobPool = async (payload) => {
  try {
    const token = await getToken();
    const response = await fetch(`${URL}/resume/job/match/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    });

    if (response.status === 401 || response.status === 403) {
      window.localStorage.clear();
      window.sessionStorage.clear();
      window.location.href = "/auth/login";
      return;
    } else if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response;
  } catch (error) {
    if (error.message.includes("401") || error.message.includes("403")) {
      window.localStorage.clear();
      window.sessionStorage.clear();
      window.location.href = "/auth/login";
    }
    throw catchError(error);
  }
};

export const CandidateDelete = async (id, payload) => {
  try {
    const response = await PUT(`${URL}/resume/remove/${id}`, payload, {});
    return response;
  } catch (error) {
    throw catchError(error);
  }
};

export const ResumeShare = async (id, payload) => {
  try {
    const response = await POST(
      `${URL}/resume/share/resume/${id}`,
      payload,
      {}
    );
    return response.data;
  } catch (error) {
    throw catchError(error);
  }
};

//Attachment
export const CandidateAttachementCreateCall = async (job_id, payload) => {
  try {
    const response = await POST(
      `${URL}/resume/attachment/${job_id}`,
      payload,
      {}
    );
    return response.data;
  } catch (error) {
    throw catchError(error);
  }
};

export const CandidateAttachementTableGetCall = async (job_id) => {
  try {
    const response = await GET(`${URL}/resume/attachment/${job_id}`, {});
    return response;
  } catch (error) {
    throw catchError(error);
  }
};

export const CandidateAttachementDownload = async (job_id) => {
  try {
    const token = await getToken();
    const response = await fetch(
      `${URL}/resume/attachment/download/${job_id}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (response.status === 401 || response.status === 403) {
      window.localStorage.clear();
      window.sessionStorage.clear();
      window.location.href = "/auth/login";
      return;
    } else if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response;
  } catch (error) {
    if (error.message.includes("401") || error.message.includes("403")) {
      window.localStorage.clear();
      window.sessionStorage.clear();
      window.location.href = "/auth/login";
    }
    throw catchError(error);
  }
};

export const CandidateAttachementDelete = async (id) => {
  try {
    const response = await DELETE(`${URL}/resume/attachment/${id}`, {});
    return response;
  } catch (error) {
    throw catchError(error);
  }
};

export const CandidateAttachementViewGetCall = async (job_id) => {
  try {
    const response = await GET(`${URL}/resume/attachment/view/${job_id}`, {});
    return response;
  } catch (error) {
    throw catchError(error);
  }
};

export const CandidateEditProfile = async (id, payload) => {
  try {
    const response = await PUT(`${URL}/resume/basic/info/${id}`, payload, {});
    return response;
  } catch (error) {
    throw catchError(error);
  }
};

export const CandidateMultiEmail = async (payload) => {
  try {
    const response = await POST(`${URL}/resume/share/hotlist`, payload, {});
    return response.data;
  } catch (error) {
    throw catchError(error);
  }
};

export const CandidateStatusChange = async (payload) => {
  try {
    const response = await PUT(`${URL}/resume/change/status`, payload, {});
    return response;
  } catch (error) {
    throw catchError(error);
  }
};

export const CandidateEnrichResume = async (params) => {
  try {
    const response = await GET(`${URL}/resume/resumedata`, params);
    return response;
  } catch (error) {
    throw catchError(error);
  }
};

//Build Pipeline
export const BuildPipelineSearch = async (payload) => {
  try {
    const response = await POST(`${URL}/intake/search/string`, payload, {});
    return response.data;
  } catch (error) {
    throw catchError(error);
  }
};

export const SeachExternalDataBase = async (payload) => {
  try {
    const response = await POST(
      `${URL}/intake/pipeline/resumes/list`,
      payload,
      {}
    );
    return response.data;
  } catch (error) {
    throw catchError(error);
  }
};

export const SeachExternalDataBaseRowClick = async (payload) => {
  try {
    const response = await POST(`${URL}/intake/l3/resumes/fetch`, payload, {});
    return response.data;
  } catch (error) {
    throw catchError(error);
  }
};

//Candidate Sourcing
export const CandidateBuildPipeline = (value) => {
  return {
    type: CANDIDATE.candidateBuildPipeline,
    data: value,
  };
};

export const ReferenceShareClick = async (payload) => {
  try {
    const response = await POST(
      `${URL}/matchengine/reference/share/`,
      payload,
      {}
    );
    return response.data;
  } catch (error) {
    throw catchError(error);
  }
};

export const AddToJobPoolBuffer = (data) => {
  return {
    type: CANDIDATE.addToJobPool,
    data: data,
  };
};

export const GetCalendlyEventTypes = async () => {
  try {
    const response = await GET(`${URL}/customers/calendly/event-types/`, {});
    return response;
  } catch (error) {
    throw catchError(error);
  }
};

export const SendCalendlyInvite = async (match_id, payload) => {
  try {
    const response = await POST(
      `${URL}/matchengine/match/${match_id}/calendly-invites/`,
      payload,
      {}
    );
    return response.data;
  } catch (error) {
    throw catchError(error);
  }
};

export const CandidateRescore = async (id) => {
  try{
    const token = await getToken();
    const response = await fetch(`${URL}/resume/rescore/${id}`,{
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "content-type": "application/json",
      }
    });

    if(response.status === 401 || response.status === 403){
      window.localStorage.clear();
      window.sessionStorage.clear();
      window.location.href = "/auth/login";
      return;
    } else if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response;
  } catch (error) {
    if (error.message.includes("401") || error.message.includes("403")) {
      window.localStorage.clear();
      window.sessionStorage.clear();
      window.location.href = "/auth/login";
    }
    throw catchError(error);
  }
};
export const CandidateFilter = (filter) => ({
  type: "SET_CANDIDATE_FILTER",
  payload: filter,
});